<template lang="html">
  <v-card :class="{'animate__animated animate__wobble':loginFailed}">

    <v-card-title primary-title>
        <div class="headline text-xs-center w-100">Login</div>
    </v-card-title>

    <v-form @submit.prevent="submitLogin()">

      <v-card-text v-if="!isLoggingIn" class="text-xs-left">
        <v-text-field label="Email" v-model="login.email"></v-text-field>
        <v-text-field label="Password" type="password" v-model="login.password"></v-text-field>
        <span class="primary--text pointer" @click="forgotAccount()">Forgot your password?</span>
      </v-card-text>

      <v-card-text v-else class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-card-text>

      <v-card-actions v-if="!isLoggingIn">
        <v-spacer></v-spacer>
        <v-btn type="submit" flat color="primary">Login</v-btn>
      </v-card-actions>
    </v-form>

  </v-card>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  data: function () {
    return {
      loginFailed: false,
      isLoggingIn: false,
      login:{
        email: null,
        password: null
      }
    }
  },
  methods: {
    ...mapActions([
      'getAuthToken'
    ]),
    forgotAccount: function () {
      this.$emit('toggle')
    },
    submitLogin: function () {
      this.isLoggingIn = true

      this.getAuthToken(this.login).then(response => {
        this.isLoggingIn = false
        if(response){
          this.$router.push({name:'AlbumList'})
        } else {
          this.loginFailed = true;
          setTimeout(() => {
            this.loginFailed = false
          }, 500);
        }
      }).catch(() => {
        this.isLoggingIn = false
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
